import React, { createContext, useContext, useState, useMemo } from 'react';
import type { FC, ReactNode } from 'react';

type ObjectCommentContextValue = {
	expanded: boolean;
};

type ObjectCommentDispatchContextValue = {
	expandCommentContainer: () => void;
	closeCommentContainer: () => void;
};

export const ObjectCommentDispatchContext = createContext<ObjectCommentDispatchContextValue>({
	expandCommentContainer: () => {},
	closeCommentContainer: () => {},
});
ObjectCommentDispatchContext.displayName = 'ObjectCommentDispatchContext';

export const ObjectCommentContext = createContext<ObjectCommentContextValue>({
	expanded: false,
});
ObjectCommentContext.displayName = 'ObjectCommentContext';

type ObjectCommentProviderProps = {
	children: ReactNode;
};

export const ObjectCommentProvider: FC<ObjectCommentProviderProps> = ({ children }) => {
	const [expanded, setExpanded] = useState(false);

	const providerValue = useMemo(
		() => ({
			expanded,
		}),
		[expanded],
	);

	const dispatchProviderValue = useMemo(
		() => ({
			expandCommentContainer: () => {
				setExpanded(true);
			},
			closeCommentContainer: () => {
				setExpanded(false);
			},
		}),
		[setExpanded],
	);

	return (
		<ObjectCommentContext.Provider value={providerValue}>
			<ObjectCommentDispatchContext.Provider value={dispatchProviderValue}>
				{children}
			</ObjectCommentDispatchContext.Provider>
		</ObjectCommentContext.Provider>
	);
};

export const useObjectCommentContext = () => {
	return useContext(ObjectCommentContext);
};

export const useObjectCommentDispatchContext = () => {
	return useContext(ObjectCommentDispatchContext);
};
